/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core
import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { PlansDetails, AutoPayPlanDetails }  from '@experience/shop/plan-details/interfaces/family-details.interface';
import { PlanOption } from '@support/api/proxies/responses/api-2117.interface';

// Constants
// Interfaces

/**
 * Component for the UI footer.
 * @access protected - used by the Root module
 */
@Component({
  selector: 'tmo-autopay-discount',
  //encapsulation: ViewEncapsulation.None, // allows for style sheet to insert global styles
  templateUrl: './autopay-discount.component.html',
})
export class AutopayDiscountComponent implements OnInit, OnDestroy{
  @Input() public content: string;
  @Input() public set planOption(planOption :PlanOption) {
    this.planObj = <AutoPayPlanDetails>planOption;
  }
  @Input() public set plan(planDetails :PlansDetails) {
    this.planObj = <AutoPayPlanDetails>planDetails;
  }
  @Output() public openInfoModal: EventEmitter<boolean>;
  public planObj: AutoPayPlanDetails;
  @ViewChild('discountContentDIV') discountContentDIV: ElementRef;
  
  public discountContent: SafeHtml;

  constructor(
    private commonUtilService: CommonUtilService,
    private sanitizer: DomSanitizer
  ) {
    this.discountContent = null;
    this.openInfoModal = new EventEmitter<boolean>();
  }

  public ngOnInit(): void {
    this.discountContent = this.getFormattedContent();
  }

  public ngOnDestroy(): void {
    this.openInfoModal.emit(false);
  }

  public openDiscountModal(event: PointerEvent): any {
    if ((event.target as HTMLElement).id == 'discount-modal')
      this.openInfoModal.emit(true);
  }

  private getFormattedContent():  SafeHtml{
    try {
      const discountValue = String(Number(this.planObj?.displayPrice || this.planObj?.monthlyPrice?.displayValue) - Number(this.planObj?.autopayDiscDetails?.displayValue));
      return this.sanitizer.bypassSecurityTrustHtml(this.commonUtilService.messageFormatter(this.content, 
        [this.planObj?.autopayDiscDetails?.displayValue, this.planObj?.autopayDiscDetails?.price, discountValue]));
    } catch (e) {
      console.warn(e);
    }
  }
}
